import React from 'react';
import './css/Loading.css'; // Create a CSS file for styling
import { t } from 'ttag';

function Loading() {
  const reloadPage = () => {
    window.location.reload(); // Simple page reload
  };

  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p className="loading-text">{t`Loading...`}</p>
      <button className="reload-button" onClick={reloadPage}>
        {t`Retry`}
      </button>
    </div>
  );
}

export {Loading};